<template>
  <component :is="as" class="w-menu-list">
    <slot>
      <w-menu-item
        v-for="item in list"
        :key="item.code"
        :label="item.text"
        :selected="selectedItem?.code === item.code"
        @click="onClick(item)"
      />
    </slot>
  </component>
</template>

<script setup>
  import WMenuItem from '@/components/menu/WMenuItem'

  const emit = defineEmits(['clickItem'])
  const props = defineProps({
    as: {
      type: String,
      default: 'ul',
    },
    list: {
      type: Array,
      default: () => [],
    },
    selectedItem: {
      type: Object,
      default: () => {},
    },
  })
  const onClick = (item) => {
    emit('clickItem', item)
  }
</script>

<script>
  export default {
    name: 'WMenuList',
  }
</script>

<style lang="scss" scoped>
  .w-menu-list {
    display: grid;
    grid-template-columns: repeat(auto-fill);
    grid-auto-flow: column;
    justify-content: start;
    gap: 20px;
    &:last-child {
      margin-right: 0;
    }
  }
</style>
